export const allAccountParamsSelector = (state) => state.account.params;
export const accountSelector = (state) => state.account.currentAccount;
export const allAccountSelector = (state) => state.account;
